import { render, staticRenderFns } from "./companyDetails.vue?vue&type=template&id=6f5893fb&scoped=true"
import script from "./companyDetails.vue?vue&type=script&lang=js"
export * from "./companyDetails.vue?vue&type=script&lang=js"
import style0 from "./companyDetails.vue?vue&type=style&index=0&id=6f5893fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5893fb",
  null
  
)

export default component.exports